module.exports = __webpack_public_path__ + "static/media/Austin-Green.8c48befd.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Austin-Green.jpeg
// module id = 177
// module chunks = 0